import { calculateDRASTIC, calculateGODandAVI, getCalculationByCaptureId } from "../api/methods";
import { DrasticEppnaResult, GodAviResult, Method } from "../types/interfaces/methods";

export interface MethodConfig<TInputs, TResult = any> {
  method: Method;
  labelKey: string;

  calculate: (captureId: number, payload: TInputs) => Promise<void>;
  getResults: (captureId: number) => Promise<TResult[]>;
}

export const VULNERABILITY_METHODS_CONFIG: MethodConfig<any>[] = [
  {
    method: Method.DRASTIC_EPPNA,
    labelKey: "calculations.vulnerability.drastic-eppna.title",

    calculate: (captureId, payload) =>
      calculateDRASTIC(captureId, payload),

    getResults: async (captureId) => {
      const raw = await getCalculationByCaptureId(captureId, Method.DRASTIC_EPPNA);

      const r = raw[0];
      if (!r) return [];

      return [
        {
          id: r.id,
          inputId: r.inputId,
          inputParameters: r.inputParameters,
          results: {
            eppnaId: r.results.eppnaId,
            drasticIndex: r.results.drasticIndex,
            drasticPesticideIndex: r.results.drasticPesticideIndex,
          },
        },
      ] as DrasticEppnaResult[];
    },
  },
  {
    method: Method.GOD_AVI,
    labelKey: "calculations.vulnerability.god-avi.title",

    calculate: (captureId, payload) =>
      calculateGODandAVI(captureId, payload),

    getResults: async (captureId) => {
      const raw = await getCalculationByCaptureId(captureId, Method.GOD_AVI);

      const r = raw[0];
      if (!r) return [];

      return [
        {
          id: r.id,
          inputId: r.inputId,
          inputParameters: r.inputParameters,
          results: {
            aviIndex: r.results.aviIndex,
            godIndex: r.results.godIndex,
            aviClassification: r.results.aviClassification,
            godClassification: r.results.godClassification,
          },
        },
      ] as GodAviResult[];
    },
  }
];
